import React from "react";
import { DateTime } from "luxon";

// Timeline verticale du kit Fiche : rail continu à gauche, événements groupés
// par jour (dans l'ordre du tableau reçu), heure affichée par événement.
// `items` : { id, date (ISO), icon (suffixe Font Awesome), color (couleur CSS
// du point), badges (nœud), title (nœud), body (nœud), variant ("ft" : fond
// teinté pour les événements issus d'un système externe) }.

export const formatDayLabel = (isoDate) => {
  const label = DateTime.fromISO(isoDate).setLocale("fr").toFormat("cccc d MMMM yyyy");
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const formatTime = (isoDate) => DateTime.fromISO(isoDate).toFormat("HH:mm");

export const groupItemsByDay = (items) => {
  const groups = [];
  items.forEach((item) => {
    const day = DateTime.fromISO(item.date).toFormat("yyyy-MM-dd");
    const last = groups[groups.length - 1];
    if (last && last.day === day) last.items.push(item);
    else groups.push({ day, label: formatDayLabel(item.date), items: [item] });
  });
  return groups;
};

const Timeline = ({ items = [], emptyMessage = "Aucun événement.", ariaLabel }) => {
  if (!items.length) return <p className="tl__empty">{emptyMessage}</p>;

  return (
    <div className="tl" aria-label={ariaLabel}>
      {groupItemsByDay(items).map((group) => (
        <section key={group.day} className="tl__group">
          <h3 className="tl__day">{group.label}</h3>
          <ol className="tl__items">
            {group.items.map((item, k) => (
              <li
                key={item.id ?? `${group.day}-${k}`}
                className={`tl__item${item.variant ? ` tl__item--${item.variant}` : ""}`}
              >
                <span className="tl__dot" style={{ background: item.color }} aria-hidden="true">
                  {item.icon && <i className={`fa fa-${item.icon}`} />}
                </span>
                <div className="tl__card">
                  <div className="tl__meta">
                    {item.badges}
                    <time className="tl__time" dateTime={item.date}>
                      {formatTime(item.date)}
                    </time>
                  </div>
                  {item.title && <h4 className="tl__title">{item.title}</h4>}
                  {item.body}
                </div>
              </li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
};

export default Timeline;
